import React, { useEffect, useState } from "react";
import { Layout, Menu, Drawer, Button, Grid, Affix, Dropdown, Row, Col } from "antd";
import { MenuOutlined, DownOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { SelectCustomCampeonatos } from "./selectCustomCampeonatos";


const { Header } = Layout;
const { useBreakpoint } = Grid;

export const Navbar = ({
  campeonatosFiltrados,
  handleCampeonatoChange,
  campeonatoSeleccionado
}) => {
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [asociaciones, setAsociaciones] = useState([]);
  const [asociacionActiva, setAsociacionActiva] = useState(null);
  const { siglas } = useParams(); // ¡Cambiamos el nombre del parámetro!
  const navigate = useNavigate();

  const showDrawer = () => setDrawerVisible(true);
  const onClose = () => setDrawerVisible(false);

  useEffect(() => {
    const fetchAsociaciones = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_DOMINIO}/asociaciones-publicas`
        );
        if (response.status === 200) {
          const asociacionesData = response.data;
          setAsociaciones(asociacionesData);
          // Buscamos por siglas en lugar de ID numérico
          if (siglas) {
            const foundAsoc = asociacionesData.find(
              (asoc) => asoc.siglas.toLowerCase() === siglas.toLowerCase()
            );
            if (foundAsoc) {
              setAsociacionActiva(foundAsoc);
              return;
            }
          }

          // Si no hay coincidencia, tomamos la primera por defecto
          setAsociacionActiva(asociacionesData[0] || null);
        }
      } catch (error) {
        console.error("Error al obtener asociaciones:", error);
      }
    };

    fetchAsociaciones();
  }, [siglas]);

  const [selectedKey, setSelectedKey] = useState("");

  const handleItemClick = (key, id, e) => {
    e.preventDefault();
    setSelectedKey(key);

    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 64;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      if (!screens.md) onClose();
    }
  };

  useEffect(() => {
    setSelectedKey("resultados"); // o el primer key del menú
  }, []);


  const handleScroll = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 64;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      if (!screens.md) onClose();
    }
  };

  // Menú desplegable para seleccionar asociación

  return (
    <Affix offsetTop={0}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          height: "64px",
          position: "sticky",
          backgroundColor: "var(--rojo)"
        }}
      >

        {/* Menú de navegación */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            flex: 1,
            // marginLeft: "20px",
          }}
        >
          {/* <span
          style={{
            width: "22%",
          }}></span> */}
          {screens.md ? (
            <Menu
              theme="dark"
              mode="horizontal"
              selectedKeys={[selectedKey]}
              items={[
                { key: "resultados", label: "Resultados", id: "resultados" },
                { key: "pilotos", label: "Pilotos", id: "pilotos" },
                { key: "calendarios", label: "Calendarios", id: "calendarios" },
                { key: "reglamentos", label: "Reglamentos", id: "reglamentos" },
              ].map((item) => ({
                key: item.key,
                label: (
                  <a
                    href={`/#${item.id}`}
                    onClick={(e) => handleItemClick(item.key, item.id, e)}
                  >
                    {item.label}
                  </a>
                ),
                className: item.key === selectedKey ? "active-item-nav" : "",
              }))}
              style={{
                lineHeight: "64px",
                fontSize: "14px",
                borderBottom: 0,
                maxWidth: "100%",
                justifySelf: "start",
                width: "35%",
                backgroundColor: "var(--rojo)"
              }}
            />

          ) : (
           
            <Button className="button-nav-categorias" type="text"  onClick={showDrawer} > MENÚ / CAMPEONATO</Button>
          )}

        {screens.md ? (
          <div
          style={{
            justifyContent: "start",
            width: "35%"
          }}>
            <SelectCustomCampeonatos
              elPlaceholder="Año"
              arrayOpciones={campeonatosFiltrados} // Debe ser los campeonatos de la categoría activa
              textoOpciones={(opcion) => `${opcion.nombre_campeonato} ${opcion.año}`}
              onChange={handleCampeonatoChange}
              elValue={campeonatoSeleccionado} // Valor seleccionado por defecto
            />
        </div>
        ) : (
          "")}
        
        {/* Logo */}
        <div
          className="logo"
          style={{
            width: "35%",
            height: "64px",
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            overflow: "hidden",
          }}
          >
          <img
            src={
              asociacionActiva?.imagen
                ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${asociacionActiva.id}/IMAGENES/ASOCIACIONES/${asociacionActiva.imagen}`
                : "/img/default-asociacion.svg"
            }
            alt="Logo Asociación"
            style={{
              maxWidth: "80%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
          
        </div>
        {/* Drawer para móviles */}
        <Drawer
          title="Menú"
          placement="left"
          closable
          onClose={onClose}
          open={drawerVisible}
        >
          <Menu
            theme="light"
            mode="vertical"
            selectedKeys={[selectedKey]}
            items={[
              { key: "resultados", label: "Resultados", id: "resultados" },
              { key: "pilotos", label: "Pilotos", id: "pilotos" },
              { key: "calendarios", label: "Calendarios", id: "calendarios" },
              { key: "reglamentos", label: "Reglamentos", id: "reglamentos" },
            ].map((item) => ({
              key: item.key,
              label: (
                <a
                  href={`/#${item.id}`}
                  onClick={(e) => handleItemClick(item.key, item.id, e)}
                >
                  {item.label}
                </a>
              ),
              className: item.key === selectedKey ? "active-item-nav" : "",
            }))}
          />

          <div>
            <SelectCustomCampeonatos 
              elPlaceholder="Año"
              arrayOpciones={campeonatosFiltrados} // Debe ser los campeonatos de la categoría activa
              textoOpciones={(opcion) => `${opcion.nombre_campeonato} ${opcion.año}`}
              onChange={handleCampeonatoChange}
              elValue={campeonatoSeleccionado} // Valor seleccionado por defecto
            />
          </div>
        </Drawer>
      </Header>
    </Affix>
  );
};
